// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Translations
import { withTranslation } from "react-i18next";
// Styles
import "components/Accordion/styles/styles.scss";
// Components
import { SelectSimple } from "@components/Input";
import { get_agents } from "api/application/Customers";
import { get_users } from "api/application/Users";
// Helpers
import { returnElementFromArray } from "@helpers";
import { IntentsAPI } from "views/Bots/NLP/application/Build/Tabs/Intents/infrastructure";

class Centridesk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: false,
      groups: [],
    };
  }
  componentDidMount = () => {
    this.getUsers();
    this.getGroups();
    const { intent } = this.props;
    let role_type = "";
    if (intent.desks.info.agent_id) {
      role_type = "agent";
    } else if (intent.desks.info.group_id) {
      role_type = "group";
    }
    this.setState({ role_type });
  };

  getUsers = () => {
    get_users(this.props).then((users) => {
      this.setState({ users: users });
    });
  };

  getGroups = async () => {
    const { access, actualProject, user } = this.props.data;
    try {
      const obj = new IntentsAPI(actualProject.id, access, this.props);
      const groups = await obj.get_account_groups(user.account_id);
      this.setState({ groups: groups });
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };

  updateSelectorElement = (e, type) => {
    const { intent, updateIntent } = this.props;
    const roleType = e?.id === "-" ? null : e.id;
    let newIntent = JSON.parse(JSON.stringify(intent)); 
    switch (type) {
      case "agent_id":
        newIntent.desks.info = {
          ...newIntent.desks.info,
          [type]: roleType,
        };
        break;
      case "group_id":
        newIntent.desks.info = {
          ...newIntent.desks.info,
          [type]: roleType,
        };
        break;
      case "centridesk_ticket_status":
        newIntent.desks.info = {
          ...newIntent.desks.info,
          centridesk_mode:
            e === "solved" ? "bot" : newIntent.desks.info.centridesk_mode,
          [type]: e,
        };
        break;
      case "centridesk_mode":
        newIntent.desks.info = {
          ...newIntent.desks.info,
          [type]: e,
        };
        break;
      default:
        break;
    }
    updateIntent(newIntent);
  };

  handleSelectorValue = (item, type) => {
    const { t } = this.props;
    const { users, role_type } = this.state;
    var value = item?.[type];
    switch (type) {
      case "agent_id":
        if (!value) {
          return "-";
        } else {
          var user = returnElementFromArray(value, users, "id");
          if (!user) {
            return "-";
          }
          return `${user.first_name} ${user.last_name}`;
        }
      case "group_id":
        if (!value) {
          return "-";
        } else {
          var group = returnElementFromArray(value, this.state.groups, "id");
          if (!group) {
            return "-";
          }
          return group.name;
        }
      case "role_type":
        if (!role_type || role_type === "-") {
          return "-";
        } else {
          return t(`common:intents.integrations.role_type.${role_type}`);
        }
      case "centridesk_ticket_status":
        if (!value) {
          return (
            <span className={"status new"}>
              {t("elements.custom.status.new")}
            </span>
          );
        } else {
          return (
            <span className={`status ${value}`}>
              {t(`elements.custom.status.${value}`)}
            </span>
          );
        }
      default:
        break;
    }
  };

  render() {
    const { intent, t } = this.props;
    const { roles } = this.props.data;
    const { users, groups, role_type } = this.state;
    return (
      users.length > 0 && (
        <div className={"info__integration"}>
          <div className={"info__integration_content"}>
            <SelectSimple
              valueSelected={this.handleSelectorValue(role_type, "role_type")}
              items={[
                { id: "-", name: "-" },
                {
                  id: "agent",
                  name: t("common:intents.integrations.role_type.agent"),
                },
                {
                  id: "group",
                  name: t("common:intents.integrations.role_type.group"),
                },
              ]}
              label={t("common:intents.integrations.role_type.label")}
              onSelect={(e) => {
                this.setState({ role_type: e.id });
                const { intent, updateIntent } = this.props;
                const newIntent = {
                  ...intent,
                  desks: {
                    ...intent.desks,
                    info: {
                      ...intent.desks.info,
                      agent_id: null,
                      group_id: null,
                    },
                  },
                };
                updateIntent(newIntent);
              }}
              placeholder={t("common:intents.integrations.role_type.label")}
              type={"role"}
              className={"select_secondary nodrag"}
              t={t}
            />
            {role_type === "agent" && (
              <SelectSimple
                valueSelected={this.handleSelectorValue(
                  intent.desks.info,
                  "agent_id"
                )}
                items={get_agents(users, roles)}
                label={t("common:intents.integrations.agent_id")}
                onSelect={(e) => this.updateSelectorElement(e, "agent_id")}
                placeholder={t("common:intents.integrations.agent_id")}
                type={"channel_centridesk_selector"}
                className={"select_secondary nodrag"}
                t={t}
              />
            )}
            {role_type === "group" && (
              <SelectSimple
                valueSelected={this.handleSelectorValue(
                  intent.desks.info,
                  "group_id"
                )}
                items={groups.map((g) => ({ id: g.id, name: g.name }))}
                label={t("common:intents.integrations.group_option")}
                onSelect={(e) => this.updateSelectorElement(e, "group_id")}
                placeholder={t("common:intents.integrations.group_option")}
                type={t("common:intents.integrations.group_option")}
                className={"select_secondary nodrag"}
                t={t}
              />
            )}
            <SelectSimple
              valueSelected={this.handleSelectorValue(
                intent.desks.info,
                "centridesk_ticket_status"
              )}
              items={["new", "open", "pending", "solved"]}
              label={t("common:intents.integrations.centridesk_ticket_status")}
              onSelect={(e) =>
                this.updateSelectorElement(e, "centridesk_ticket_status")
              }
              placeholder={t(
                "common:intents.integrations.centridesk_ticket_status"
              )}
              type={"status"}
              className={"select_secondary nodrag"}
              t={t}
            />
            <SelectSimple
              valueSelected={intent.desks.info.centridesk_mode}
              items={["desk", "bot"]}
              label={t("common:intents.integrations.mode")}
              onSelect={(e) => this.updateSelectorElement(e, "centridesk_mode")}
              placeholder={t("common:intents.integrations.mode")}
              disabled={intent.desks.info.centridesk_ticket_status === "solved"}
              className={"select_secondary nodrag"}
              t={t}
            />
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const channel = connect(mapStateToProps)(Centridesk);

export default withTranslation(["commons", "common", "languages"])(channel);
